export default __webpack_public_path__ + "static/woman-developer-thinking-ab64855481912f3faf64120e6a4d2c60.webp";